import { Flex } from '@mantine/core';
import styled from 'styled-components';

export const PreviewFilesContainer = styled(Flex).attrs(() => ({
	direction: 'column',
	gap: '1rem',
	w: '100%',
	h: '100%',
	p: '1rem',
}))``;

export const DocumentViewContainer = styled(Flex).attrs(() => ({
	direction: 'column',
	gap: '1rem',
	h: '100%',
	w: '100%',
}))`
	overflow: hidden;
	position: relative;
`;

export const PdfScroll = styled.div`
	flex-grow: 1;
	display: flex;
	justify-content: center;
	overflow: auto;
	position: relative;
	padding: 1rem;
	width: 100%;
	border-radius: 0.5rem;
	background-color: ${(props) => props.theme.v3.colors.gray[0]};
`;

export const ImageScroll = styled.div`
	flex-grow: 1;
	display: flex;
	justify-content: center;
	align-items: flex-start;
	overflow: auto;
	padding: 1rem;
	width: 100%;
	border-radius: 0.5rem;
	background-color: ${(props) => props.theme.v3.colors.gray[0]};
`;

export const StyledImg = styled.img<{ $scale: number }>`
	max-width: 100%;
	transform: ${({ $scale }) => `scale(${$scale})`};
	transform-origin: top center;
	object-fit: contain;
`;
